import React, { useState } from 'react';
import { Box, Button, useMediaQuery, useTheme } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const OptionButtons = ({ options, onSelect }) => {
  const theme = useTheme();
  // eslint-disable-next-line no-unused-vars
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [showAll, setShowAll] = useState(false);
  
  // Only show the first 5 options if there are more than 5 options
  const shouldCollapse = options.length > 5;
  const displayedOptions = shouldCollapse && !showAll ? options.slice(0, 5) : options;

  const toggleShowAll = () => {
    setShowAll(!showAll);
  };
  
  return (
    <Box sx={{ 
      mt: { xs: 0.75, sm: 1 },
      display: 'flex',
      flexDirection: 'column',
      gap: { xs: 0.5, sm: 1 },
      width: '100%'
    }}>
      {displayedOptions.map((option, index) => (
        <Button
          key={index}
          variant="outlined"
          fullWidth
          onClick={() => onSelect(option)}
          sx={{
            fontSize: { xs: '0.75rem', sm: '0.875rem' },
            justifyContent: 'flex-start',
            textTransform: 'none',
            borderColor: 'rgba(0, 0, 0, 0.12)',
            color: 'text.primary',
            backgroundColor: 'white',
            '&:hover': {
              borderColor: 'primary.main',
              backgroundColor: 'rgba(25, 118, 210, 0.04)',
            },
            padding: { xs: '8px 12px', sm: '10px 15px' },
            borderRadius: '8px',
            lineHeight: 1.2,
            minHeight: { xs: '32px', sm: '36px' },
          }}
        >
          {option}
        </Button>
      ))}
      
      {shouldCollapse && (
        <Button
          variant="text"
          size="small"
          onClick={toggleShowAll}
          startIcon={showAll ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          sx={{
            fontSize: '0.8rem',
            color: '#9D1680',
            mt: 0.5,
            alignSelf: 'center',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: 'rgba(157, 22, 128, 0.08)',
            },
          }}
        >
          {showAll ? 'Show Less' : 'Show More'}
        </Button>
      )}
    </Box>
  );
};

export default OptionButtons; 